const scanning= {
    inserted:function (el, binding) {
      let {type = "input", fn, event = "keydown",time = 300} = binding.value
      let keyDownTime=""
      let keyUpTime=""
      const targetEl = el.getElementsByTagName("input")[0];
      let timer
      targetEl.addEventListener(event, () => {
         keyDownTime = new Date().getTime();
      })
      targetEl.addEventListener("keyup", () => {
        keyUpTime = new Date().getTime();
        if (keyUpTime - keyDownTime < 25) {
          timer && clearTimeout(timer)
          timer = setTimeout(() => {
            fn(targetEl.value)
          }
         ,time)
        }
      })
  }}
  export default scanning


// WEBPACK FOOTER //
// ./src/directives/src/scanning.js